import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=d7d4d4a0&"
import script from "./Logo.vue?vue&type=script&lang=ts&"
export * from "./Logo.vue?vue&type=script&lang=ts&"
import style0 from "./Logo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d7d4d4a0')) {
      api.createRecord('d7d4d4a0', component.options)
    } else {
      api.reload('d7d4d4a0', component.options)
    }
    module.hot.accept("./Logo.vue?vue&type=template&id=d7d4d4a0&", function () {
      api.rerender('d7d4d4a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/Logo.vue"
export default component.exports